<div [ngClass]="{'landing-page': true,'show-mobile-menu': showMobileMenu}">
    <div class="mobile-menu" (click)="$event.stopPropagation()">
        <a (click)="scrollTo('#home')" href="javascript:;" class="logo-mobile">
            <span></span>
        </a>
    </div>

    <div class="main-container">
        <ngx-headroom class="landing-page-nav">
            <nav>
                <div class="container d-flex align-items-center justify-content-between">
                    <ul class="navbar-nav flex-row">
                        <a (click)="scrollTo('#home')" target="_blank">
                            <img alt="mobile hero" class="mobile-hero" src="\assets\img\eboks\png.png"
                                style="height:80px; margin-bottom: 30px;margin-top: 30px;" />
                        </a>
                        <li class="nav-item" style="margin-left: 0.5rem;"><a (click)="scrollTo('#home')"
                                href="javascript:;">Block Island Book Barn</a></li>
                    </ul>
                    <span class="mobile-menu-button" (click)="showMobileMenu=!showMobileMenu; $event.stopPropagation()">
                    </span>
                </div>
            </nav>
        </ngx-headroom>


        <div class="content-container" id="home">
            <div class="section home">
                <div class="container">
                    <div class="row home-row">
                        <div class="col-12 d-block d-md-none">
                            <a  target="_blank">
                                <img alt="mobile hero" class="mobile-hero"
                                    src="\assets\img\eboks\png.png"/>
                            </a>
                        </div>
                        <div class="col-12 col-xl-6 col-lg-5 col-md-6">
                            <div class="home-text">
                                <div class="display-1">Block Island Book Barn<br/></div>
                                <p class="white mb-5">
                                   Welcome to Block Island Book Barn!
                                   Home of the largest selection of new
                                    and used books on Block Island
                                  <br />
                                    <br/>
                                    <br/>
                                  Come in and browse, order ahead
                                    for pickup or delivery via our
                                      expert moped courier force
                                    <br />
                                    <br />
                                    <!-- Hope you enjoy it! -->
                                </p>
                              <form #loginForm="ngForm" novalidate (ngSubmit)="onSubmit()">
                                <div class="input-group mb-3">
                                  <input type="text" class="form-control" placeholder="Enter Your Phone Number" aria-label="Enter Your Phone Number"
                                         aria-describedby="basic-addon2" name="MobileNo" [(ngModel)]="MobileNoModel">
                                  <div class="input-group-append">
                                    <button class="btn btn-outline-secondary" (click)="loginWithPhoneMidSecret()"  type="button" style="color: white; border-color: white;">Login</button>
                                  </div>
                                </div>
                              </form>
                            </div>
                        </div>
                        <div class="col-12 col-xl-5 offset-xl-1 col-lg-7 col-md-6  d-none d-md-block" style="margin-left: 1.33333%;">
                            <a  target="_blank">
                                <img alt="hero" src="\assets\img\eboks\png.png" style="margin-top: -90px; width: 600px; padding-left: 87px;margin-left: 0px"/>
                            </a>
                        </div>
                        <div class="container copyright pt-5 pb-5">
                            <div class="row">
                                <div class="col-12"></div>
                                <div class="col-12 text-center">
                                    <p class="white mb-5">2022 © Block Island Book Born</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
